import { Box, Card, CardContent, Typography, Grid, Autocomplete, TextField, Button, Checkbox, Switch } from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import {gdePermissionOpts} from '../utils';
import { updateGDEAccess } from "redux/actions/addEditWorker";
import { getWorkerGdeRole, getWorkerIMTimeRole} from "services/workerSchedule";
import { isEmptyObject } from "utils/index";

const GlobalDataEntry = ({handleChange}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  const empId = location.state && location.state.empId ? location.state.empId : '';
  const approveForMgr = location.state && location.state.approveForManager
                            ? location.state.approveForManager : {};
  const user = useSelector((state) => state.user.auth.user);
  const countries  = useSelector((state) => state.appConfig.countries);
  const gdeData = useSelector(state => state.addEditWorker.workerRoles.gde || {});
  const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
  const imtRole = useSelector((state) => state.user.imtRole || null);
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
  const [disableSave, setDisableSave] = useState(true);
  const [gdeRolesOptions, setgdeRolesOptions] = useState(["Data Entry", "Supervisor", "Admin"]);
  const [gdePermOptions, setGdePermOptions] = useState(gdePermissionOpts.filter(act => act.role === "Data Entry"));
  const [gdeCountryOptions, setGdeCountryOptions] = useState([]);
  const [loggedInWorkerGDERole, setLoggedInWorkerGDERole]=useState(null);
  const [loggedInWorkerIMTimeRole, setloggedInWorkerIMTimeRole] = useState(null);
  const [readOnly, setReadOnly] = useState(true);

  const prevUser = React.useRef();
    useEffect(()=>{
      console.log("gde countries", countries);
      if(user?.workerId && user?.workerId !== prevUser.current?.workerId){
      getWorkerIMTimeRole(user?.workerId)
            .then((data) => {
              console.log("loggedIn worker imtRole", data);
              setloggedInWorkerIMTimeRole(data)
        });
      getWorkerGdeRole(user?.workerId).then((data)=>{
        console.log("loggedIn worker gdeRole", data);
        setLoggedInWorkerGDERole(data);
      })
      if(countries && countries.length>0){
        setGdeCountryOptions(countries.map(item => item.countryName))
      }
      prevUser.current = user;
      }
    },[user])

    useEffect(() => {
      console.log("IMTime Role", imtRole)
      if(imtRole?.userRole?.role !== "Support"){
            setReadOnly(false);
          }
    },[imtRole])


    useEffect(() => {  
      if(loggedInWorkerGDERole!=null && loggedInWorkerIMTimeRole!=null){
          if(!isEmptyObject(loggedInWorkerGDERole) && !isEmptyObject(loggedInWorkerIMTimeRole)){
            if(loggedInWorkerGDERole?.gdeRole==='Super User' && loggedInWorkerIMTimeRole?.role === 'Admin'){
              let filteredRoles=[...gdeRolesOptions,'Super User']
              setgdeRolesOptions(filteredRoles)
            }
          }
        }
      }, [loggedInWorkerGDERole, loggedInWorkerIMTimeRole]);

  useEffect(() => {
    if(gdeData && Object.keys(gdeData).length>0){
      console.log("gde gdeData", gdeData);
      const data = _.cloneDeep(gdeData || {});
      // if(data?.additionalPermissions?.length>0){
      //   data.additionalPermissions = data.additionalPermissions.filter(item => item.enabled);
      // }
      setFormValues(data);
    }
  }, [gdeData]);

  useEffect(() => {
    console.log("gde formValues", formValues);
    validForm(formValues);
    if(formValues?.gdeRole){
      let filPermissionOpts = gdePermissionOpts.filter(act => act.role === formValues?.gdeRole);
      setGdePermOptions(filPermissionOpts);
    }
  } ,[formValues])

  const validForm = (formValues) => {
    let errors = {};
    if(formValues?.isActive){
      if(!formValues?.gdeRole){
        errors['gdeRole'] = "Field is required";
      }
      if(formValues?.gdeRole === "Super User" && !formValues?.country?.length > 0){
        errors['country'] = "Field is required";
      }
    }
    setFormErrors(errors);
    const isValid = !Object.keys(errors).length > 0 && !_.isEqual(formValues, gdeData);
    setDisableSave(!isValid);
    return isValid;
  }

  const handleCloseSnack =  () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const isValidForm = validForm(formValues);
      if(!isValidForm){
        setSnackControl({
          open: true,
          message: "Invalid data to submit. Please check!",
          severity: "info"
        })
      }
      const selectedPermissions =  formValues?.additionalPermissions?.length > 0 ?
      formValues?.additionalPermissions.filter(item => item.enabled).map(item => item.value) : [];
      const updatedPermissions =  gdePermOptions.map(item => ({
        ...item,
        enabled: selectedPermissions?.includes(item.value)
      }));
      const data = {
        actionTS: new Date().toISOString(),
        actionBy: user?.workerId,
        gdeRole: formValues?.gdeRole || "",
        additionalPermissions: updatedPermissions || [],
        country: formValues?.country || [],
        isActive: formValues?.isActive ? true : false,
        pinActive: formValues?.pinActive ? true: false,
        activityFamilyId: 'gde'
      }
      console.log("gde submit", formValues, data);
      const response = await dispatch(updateGDEAccess(data, workerData));
      if(response && response.status){
        setSnackControl({
          open: true,
          message: "GDE Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "GDE Access update failed.",
          severity: 'error'
        })
      }

    }catch(error){
      console.log("gde handleSubmit error", error);
      setSnackControl({
        open: true,
        message: "GDE Access failed to submit.",
        severity: "error"
      })
    }
  }

  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
          <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)' }}>
          {loadingRoles ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                Global Data Entry
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container rowSpacing={3} marginTop={2} paddingLeft={3}>
                  <Grid
                    container
                    columnSpacing={3}
                    marginBottom={3}
                    alignItems="center"
                  >
                    <Grid item xs={2}  md={2} lg ={0.7}>
                      <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Switch 
                        //disabled={formValues?.isActive}
                        inputProps={{ 'aria-label': 'Enable GDE Role switch' }}
                        checked={formValues.isActive}
                        onChange={(e) => {
                          let checked = e.target.checked;
                          setFormValues({ ...formValues, isActive: checked });
                        //  setDisable(false);
                        }}
                        disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} md={3}>
                      <Checkbox
                       // defaultChecked={formValues?.pinActive}
                        checked={formValues?.pinActive ? true : false}
                        name="pinActive"
                        id="pinActive"
                        inputProps={{
                          "aria-label": "controlled",
                          shrink: true,
                          readOnly: readOnly
                        }}
                        onChange={e => {
                          let checked = e.target.checked;
                          if(readOnly){
                            return
                          }
                          else{
                            setFormValues({ ...formValues, pinActive: checked });
                          }
                        }}
                        disabled={!formValues?.isActive || readOnly}
                      />
                     Pin User
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5} spacing={3} marginTop={3}>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                    <Autocomplete
                        renderInput={(params) => (
                          <TextField {...params} 
                          label="Select Role" 
                          required
                          error={formErrors?.gdeRole}
                          helperText={formErrors?.gdeRole}
                          />
                        )}
                        id="gdeRole"
                        name="gdeRole"
                        size="small"
                        options={gdeRolesOptions}
                        value={formValues?.gdeRole || ""}
                        onChange={(e, v)=>{
                          setFormValues(prevState => ({...prevState, gdeRole: v ? v : "", additionalPermissions: []}))
                        }}
                        disabled={!formValues?.isActive || readOnly}
                        readOnly={readOnly}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                    <Autocomplete
                        renderInput={(params) => (
                          <TextField 
                            {...params}
                            label="Select Country" 
                            required = {formValues?.gdeRole === "Super user"}
                            error={formErrors?.country}
                            helperText={formErrors?.country}
                            />
                        )}
                        id="country"
                        name="country"
                        size="small"
                        multiple
                        disableCloseOnSelect
                        options={gdeCountryOptions}
                        value={formValues?.country || []}
                        onChange={(e,v)=> {
                          setFormValues(prevState => ({...prevState, country: v ? v : []}))
                        }}
                        disabled={formValues?.gdeRole !== "Super User" || !formValues?.isActive || readOnly}
                        readOnly={readOnly}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                    <Autocomplete
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            label="Additional Permissions" 
                           // required
                            error={formErrors?.additionalPermissions}
                            helperText={formErrors?.additionalPermissions}
                            />
                        )}
                        id="additionalPermissions"
                        name="additionalPermissions"
                        size="small"
                        multiple
                        disableCloseOnSelect
                        options={gdePermOptions}
                        value={formValues?.additionalPermissions?.filter(item => item.enabled) || []}
                        onChange={(e,v) => {
                          if(v){
                            v= v.map(item => ({
                              ...item,
                              enabled:true
                            }))
                          }
                          setFormValues(prevState => ({...prevState, additionalPermissions: v ? v : []}))
                        }}
                        disabled={!formValues?.isActive || !formValues?.gdeRole || readOnly}
                        isOptionEqualToValue={(option, value) => value?.enabled && value?.value && option.value === value.value}
                        readOnly={readOnly}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={11}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={(e) => handleChange(e, 0)}
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                    >
                      Cancel
                    </Button>
                    <Button
                    style={{marginRight: 40, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled={disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};

export default GlobalDataEntry;
